import { trackCxFoundationsTopicCsatClick } from "@faire/web-api--source/events/cxFoundations/click/topicCsat";
import React from "react";

import { CsatCollected } from "./CsatCollected";
import { CsatQuestion } from "./CsatQuestion";

interface IProps {
  feedbackCollectedByIssueType: { [key: string]: boolean };
  issueType: string;
  setFeedbackCollected: (key: string, value: boolean) => void;
}

export const Csat: React.FC<IProps> = ({
  feedbackCollectedByIssueType,
  issueType,
  setFeedbackCollected,
}) => {
  const handleFeedbackClick = (feedback: string) => {
    trackCxFoundationsTopicCsatClick(issueType, feedback);
    setFeedbackCollected(issueType, true);
  };

  const wasCsatCollected = feedbackCollectedByIssueType[issueType];
  if (wasCsatCollected) {
    return <CsatCollected />;
  }

  return (
    <CsatQuestion
      handleYesClick={() => handleFeedbackClick("Yes")}
      handleNoClick={() => handleFeedbackClick("No")}
    />
  );
};
